// extracted by mini-css-extract-plugin
export default {"sectionMenu":"SectionMenu_sectionMenu__ZLk4S","textContainer":"SectionMenu_textContainer__9eR-D","item":"SectionMenu_item__7fd0h"};